import { EventLocationSerializer } from "@app-contexts/dashboard/features/events/data/types/events";
import { SeatingEventPropertyMap } from "@shared/modules/seating/types/seating-property-types";
import { formatDate } from "@shared/utils/dates/formatting";
import { useTranslation } from "@shared/utils/internationalization";

export function useBannerSubtitle() {
  const { t } = useTranslation("seating");

  function getDateLabel(seatingObject: SeatingEventPropertyMap) {
    let dateString = "";

    if (
      seatingObject?.starts_on &&
      seatingObject?.timezone &&
      seatingObject?.location
    ) {
      dateString = formatDate({
        date: seatingObject?.starts_on,
        timezone: seatingObject?.timezone,
        format: "EEE MMM d, yyyy @ h:mm a zzz",
      });
    } else if (
      seatingObject?.starts_on &&
      seatingObject?.ends_on &&
      seatingObject?.timezone
    ) {
      return `${formatDate({
        date: seatingObject?.starts_on,
        timezone: seatingObject?.timezone,
        format: "EEE MMM d, yyyy",
      })} - ${formatDate({
        date: seatingObject?.ends_on,
        timezone: seatingObject?.timezone,
        format: "EEE MMM d, yyyy",
      })}`;
    }

    return dateString;
  }

  function getLocationLabel(location: EventLocationSerializer) {
    // default string if location data doesn't exist
    let locationString = "";

    if (location?.name && !location?.city && !location?.province) {
      locationString = `${location.name} - ${t("Location Unavailable")}`;
    } else if (location?.name && location?.city && location?.province) {
      locationString = `${location.name} - ${location.city}, ${location.province}`;
    }

    return locationString;
  }

  return {
    getDateLabel,
    getLocationLabel,
  };
}
